/**
 * What we are trying to do here is to invalidate the cache for
 * particular queries after a particular mutation has occurred.
 */
import { ApolloLink, type NormalizedCacheObject } from '@apollo/client';
import { ApolloClient } from '@apollo/experimental-nextjs-app-support';

/**
 * This object maps mutations to the queries that should be invalidated
 */

const DEPENDENCIES_PER_MUTATIONS = {
  NotifyPlaidLinkEvent: ['nwPlusPointsSummary', 'nwPlusUserQualifiedRewards'],
};

const evictCacheLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((data) => {
    const { operationName } = operation;

    const dependencies = DEPENDENCIES_PER_MUTATIONS[operationName] as
      | string[]
      | undefined;

    if (dependencies) {
      const apolloClient = operation.getContext()
        .client as ApolloClient<NormalizedCacheObject>;

      if (apolloClient) {
        dependencies.forEach((dependency) => {
          apolloClient.cache.evict({
            fieldName: dependency,
          });
        });
      }
    }

    return data;
  });
});

export default evictCacheLink;
